export default "__VITE_ASSET__Cp7ohWCi__"